import React, { useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { Helmet } from "react-helmet";
import {
  AllGetDeshboardPlans,
  ServiceCatWise,
  ServicesDetails,
} from "../FetchAPI";
import DOMPurify from "dompurify";
import WhyChoose from "../WhyChoose/WhyChoose";
import ServicePlanBox from "./ServicePlanBox";
import "./ServiceDetailsCss.css";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Autoplay } from "swiper/modules";
import DetailsBradcrumeSection from "../Others/DetailsBradcrumeSection";
import { useAuth } from "../../Store/AuthContext";
import PlanSubmitForm from "./PlanSubmitForm";
// import ServiceDetailsForm from "./ServiceDetailsForm";
// import { useAuth } from "../../Store/AuthContext";

export default function ServiceDetails() {
  let { serviceSlug } = useParams();

  const { RendomTokenfetch, userRoll } = useAuth();

  // const [webSetting] = WebsiteSetting(RendomTokenfetch);
  // const [webSetting] = WebsiteSetting();
  const [ServiceDetails] = ServicesDetails(RendomTokenfetch, serviceSlug);
  // console.log(ServiceDetails);
  const categorySlug = ServiceDetails.category_slug;
  const [ServiceCat] = ServiceCatWise(RendomTokenfetch, categorySlug);
  const isLoopEnabled = ServiceCat.length > 4;

  const duplicatedSlides = isLoopEnabled
    ? ServiceCat
    : [...ServiceCat, ...ServiceCat];

  const Catid = ServiceDetails.category_id;
  const serviceid = ServiceDetails.service_id;
  const [serviceplan] = AllGetDeshboardPlans(
    RendomTokenfetch,
    Catid,
    serviceid,
    userRoll,
    "5",
    "1"
  );

  // console.log(serviceplan);

  // const description = ServiceDetails.description || "";
  //   const splitHTMLContent = (html, chunkSize = 500) => {
  //   const words = html.split(/\s+/);
  //   const chunks = [];

  //   for (let i = 0; i < words.length; i += chunkSize) {
  //     chunks.push(words.slice(i, i + chunkSize).join(" "));
  //   }

  //   return chunks;
  // };

  // const chunks = splitHTMLContent(description);
  // const [part1, part2, part3, part4, part5] = chunks;

  useEffect(() => {
    const buttons = document.querySelectorAll(".tabsbtnSectionBTNLink");
    buttons.forEach((btn) => {
      btn.addEventListener("click", (e) => {
        e.preventDefault();
        const targetId = btn.getAttribute("data-target");
        const targetElement = document.getElementById(targetId);

        if (targetElement) {
          const headerOffset = 80; // header ki height ke hisab se adjust karo
          const elementPosition = targetElement.getBoundingClientRect().top;
          const offsetPosition =
            elementPosition + window.pageYOffset - headerOffset;

          window.scrollTo({
            top: offsetPosition,
            behavior: "smooth",
          });
        }
      });
    });

    // cleanup
    return () => {
      buttons.forEach((btn) => {
        btn.replaceWith(btn.cloneNode(true)); // remove event listeners
      });
    };
  }, []);

  useEffect(() => {
    const sections = document.querySelectorAll(
      "#serviceDetailsvideo, #detailsservice, #serviceplans, #reviewformSection"
    );
    const navBtns = document.querySelectorAll(".tabsbtnSectionBTNLink");

    const onScroll = () => {
      let current = "";
      sections.forEach((sec) => {
        const sectionTop = sec.offsetTop - 100;
        if (window.scrollY >= sectionTop) {
          current = sec.getAttribute("id");
        }
      });

      navBtns.forEach((btn) => {
        btn.classList.remove("active");
        if (btn.getAttribute("data-target") === current) {
          btn.classList.add("active");
        }
      });
    };

    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <>
      <Helmet>
        <title>{ServiceDetails.servicetitle}</title>
        <meta name="description" content={ServiceDetails.meta_description} />
        <meta name="keywords" content={ServiceDetails.meta_keyword} />
        <link rel="canonical" href={window.location.href} />
      </Helmet>

      <DetailsBradcrumeSection
        // Pagename={ServiceDetails.servicetitle}
        Pagename={"Service Details"}
        page1={[
          { name: "Services", pagelink: "services" },
          {
            name: ServiceDetails.category,
            pagelink: `services/${ServiceDetails.category_slug}`,
          },
          { name: ServiceDetails.servicetitle },
        ]}
      />

      <section className="tabsScrollSection" id="tabsScrollSection">
        <div className="tabsBtnSectionDiv">
          <button
            data-target="serviceDetailsvideo"
            className="tabsbtnSectionBTNLink"
          >
            Services
          </button>
          <button
            data-target="detailsservice"
            className="tabsbtnSectionBTNLink"
          >
            Details
          </button>
          <button data-target="serviceplans" className="tabsbtnSectionBTNLink">
            Plans
          </button>
          <button
            data-target="reviewformSection"
            className="tabsbtnSectionBTNLink"
          >
            Review
          </button>
        </div>
      </section>

      <section className="section_padding_top" id="serviceDetails">
        <div className="detail-outer">
          <div className="auto-container" style={{ maxWidth: "1400px" }}>
            <div className="row">
              <div
                className="sidebar-column col-lg-4 col-md-12 col-sm-12"
                id="serviceDetailsvideo"
              >
                <aside className="sidebar">
                  <div className="videoouter">
                    <div className="videobox">
                      <div className="postthumbnail">
                        {" "}
                        <iframe
                          className="serviceDetailsvideo"
                          width="100%"
                          height="100%"
                          src="https://www.youtube.com/embed/wBQauoc1bj0?autoplay=1&mute=1&enablejsapi=1&controls=1&modestbranding=1&rel=0"
                          title={ServiceDetails.servicetitle}
                          frameBorder="0"
                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                          referrerPolicy="strict-origin-when-cross-origin"
                          allowFullScreen
                        ></iframe>
                      </div>
                    </div>
                  </div>
                  <div className="relealedservice">
                    <div className="blog-left-side widget mt-4">
                      <div className="widget widget_recent_data">
                        <div className="single-widget-item">
                          <h2 className="widget-title mt-0">
                            Related Services
                          </h2>
                          <div className="slider-container">
                            <Swiper
                              direction="vertical"
                              slidesPerView={4} // Change to 4 or 5 for smaller slides
                              spaceBetween={5} // Reduce space between slides
                              autoplay={{
                                delay: 2000,
                                disableOnInteraction: false,
                              }}
                              loop={ServiceCat.length > 4}
                              modules={[Autoplay]}
                              className="mySwiper"
                            >
                              {duplicatedSlides.map((valucat, index) => (
                                <SwiperSlide key={index}>
                                  <div className="recent-post-item">
                                    <div className="recent-post-image">
                                      <Link
                                        to={`/service/${valucat.service_slug}`}
                                      >
                                        <img src={valucat.image} alt="" />
                                      </Link>
                                    </div>
                                    <div className="recent-post-text">
                                      <h4>
                                        <Link
                                          to={`/service/${valucat.service_slug}`}
                                        >
                                          {valucat.title}
                                        </Link>
                                      </h4>
                                    </div>
                                  </div>
                                </SwiperSlide>
                              ))}
                            </Swiper>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </aside>
              </div>
              <div className="content-column col-lg-8 col-md-12 col-sm-12">
                <div className="">
                  <div className="serDetialstitle">
                    <h1 className="mb-4 heading-bold titleheading">
                      {ServiceDetails.servicetitle}
                    </h1>
                  </div>
                  <div
                    className="post-content entry-content"
                    id="detailsservice"
                    dangerouslySetInnerHTML={{
                      __html: DOMPurify.sanitize(ServiceDetails.description),
                    }}
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section_padding_top" id="serviceplans">
        <div className="detail-outer">
          <div className="auto-container" style={{ maxWidth: "1400px" }}>
            {serviceplan.length > 0 ? (
              <div className="row">
                <div className="serDetialstitle">
                  <h3
                    className="mb-4 heading-bold titleheading"
                    style={{ fontSize: "28px" }}
                  >
                    Pricing Packages
                  </h3>
                  <Link className="PlansViewAll" to={`/service-plans/${Catid}`}>
                    View All
                  </Link>
                </div>
                <Swiper
                  slidesPerView={3} // Change to 4 or 5 for smaller slides
                  spaceBetween={15} // Reduce space between slides
                  autoplay={{
                    delay: 2000,
                    disableOnInteraction: false,
                  }}
                  loop={serviceplan.length > 3}
                  breakpoints={{
                    320: { slidesPerView: 1 },
                    768: { slidesPerView: 2 },
                    1024: { slidesPerView: 3 },
                    1424: { slidesPerView: 3 },
                  }}
                  modules={[Autoplay]}
                  className="mySwiper"
                >
                  {serviceplan &&
                    serviceplan.map((value, index) => (
                      <SwiperSlide key={index}>
                        <ServicePlanBox
                          key={index}
                          planid={value.id}
                          title={value.title}
                          titleslug={value.slug}
                          selling_price={value.selling_price}
                          price={value.price}
                          plan_type=""
                          service_tag={value.feature_tag}
                          serviceSlug={serviceSlug}
                        />
                      </SwiperSlide>
                    ))}
                </Swiper>
              </div>
            ) : (
              ""
            )}
          </div>
        </div>
      </section>

      <section
        className="reviewformSection section_padding_top"
        id="reviewformSection"
      >
        <div className="detail-outer">
          <div className="auto-container" style={{ maxWidth: "1400px" }}>
            <div className="sec-title text-center">
              <h2 className="">Customer Review</h2>
              {/* <div className="text">
              Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do
              eiusmod tempor
            </div> */}
            </div>
            <div className="row">
              <div className="col-lg-6 col-md-12 col-sm-12 mb-2">
                <div className="review-box p-4  rounded customerReviewBox">
                  {/* Overall Rating Box */}
                  <div className="d-flex align-items-center mb-4">
                    <div className="rating-score-box text-center me-4">
                      <h2 className="rating-score">3.8</h2>
                      <p className="mb-0 text-muted">out of 5</p>
                    </div>
                    <div>
                      <div className="star-icons mb-1">★★★★☆</div>
                      <p className="mb-0 text-muted">282 reviews</p>
                    </div>
                  </div>

                  {/* Rating Breakdown */}
                  {[
                    { star: 5, count: 149 },
                    { star: 4, count: 49 },
                    { star: 3, count: 20 },
                    { star: 2, count: 17 },
                    { star: 1, count: 47 },
                  ].map((item, idx) => (
                    <div
                      key={idx}
                      className="d-flex align-items-center mb-2 rating-row"
                    >
                      <span className="me-2 star-label">{item.star} ★</span>
                      <div className="progress flex-grow-1 me-2 rating-progress">
                        <div
                          className="progress-bar bg-orange"
                          role="progressbar"
                          style={{ width: `${(item.count / 282) * 100}%` }}
                        ></div>
                      </div>
                      <span className="text-muted count-label">
                        ({item.count})
                      </span>
                    </div>
                  ))}

                  {/* Quality & Value */}
                  <div className="mt-4">
                    <div className="d-flex align-items-center mb-2">
                      <span className="me-3 quality-label">Quality</span>
                      <div className="progress flex-grow-1 me-2 rating-progress">
                        <div
                          className="progress-bar bg-orange"
                          role="progressbar"
                          style={{ width: `${(3.4 / 5) * 100}%` }}
                        ></div>
                      </div>
                      <span>3.4</span>
                    </div>
                    <div className="d-flex align-items-center">
                      <span className="me-3 quality-label">Value</span>
                      <div className="progress flex-grow-1 me-2 rating-progress">
                        <div
                          className="progress-bar bg-orange"
                          role="progressbar"
                          style={{ width: `${(3.5 / 5) * 100}%` }}
                        ></div>
                      </div>
                      <span>3.5</span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-6 col-md-12 col-sm-12">
                <PlanSubmitForm />
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Why Chhose us start */}
      <div id="whychoose">
        <WhyChoose />
        {/* Why Chhose us End */}
      </div>
    </>
  );
}
